<template lang="html">
  <div class="about">
    <div class="about-wrapper ">
      <div class="about-head">
        <h1>{{ $t('about.header') }}</h1>
        <div v-html="$t('about.headText')"></div>
      </div>
      <div class="about-main">
        <aboutWhy />
      </div>
      <div v-if="false" class="blue" @click="openModal">
        <p>{{ $t('slikovit') }}</p>
      </div>
      <div class="about-footer">
        <p class="bold">{{ $t('about.pib') }}: 102802932</p>
        <p class="second" v-html="$t('about.aboutFooterText')"></p>
        <p v-html="$t('about.aboutFooterOrg')"></p>
      </div>
    </div>
  </div>
</template>

<script>
import aboutWhy from '@/components/about/aboutWhy.vue'
import eventBus from '@/shared/eventBus.js'
export default {
  name: 'About',
  components: {
    aboutWhy
  },
  methods: {
    openModal () {
      eventBus.$emit('openModal', { component: 'imgSolution' })
    }
  }
}
</script>

<style lang="scss" scoped>
.about {
  background: #f2f2f2;
  padding-top: 30px;
  padding-bottom: 60px;
  width: 100%;
  font-family: Ubuntu;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 149.5%;
  /* identical to box height, or 22px */

  letter-spacing: 0.02em;

  color: #858585;

  .about-wrapper {
    height: 100%;
    max-width: 1600px;
    width: calc(100% - 40px);
    margin: 0 auto;
    background: white;
    padding: 40px 40px;
    box-sizing: border-box;
    justify-content: center;
    padding: 0 10%;

    .about-head {
      padding-top: 40px;
      text-align: center;

      h1 {
        font-style: normal;
        font-weight: 800;
        font-size: 27px;
        line-height: 44px;
        /* identical to box height */

        color: $text-color;
      }
      div {
        text-align: left;
      }
    }
    .about-main {
      margin-top: 20px;
      text-align: left;
    }
    .about-footer {
      margin-top: 170px;
      text-align: center;
      font-style: normal;

      .second {
        margin-top: 0px;
        margin-bottom: 19px;
      }
    }
  }
  .blue {
    padding-top: 30px;
    text-align: left;
    font-size: 1.2em;
    cursor: pointer;
    color: rgb(35, 153, 149);
  }
  .blue:hover {
    color: rgb(16, 71, 70);
  }
}
.bold {
  font-style: normal;
  font-weight: bold;
  font-size: 19px;
  line-height: 31px;
  letter-spacing: 0.06em;
}
p.bold {
  font-weight: bold;
  margin-bottom: 0px;
}
</style>
